import { render, staticRenderFns } from "./yhbHumanFace.vue?vue&type=template&id=0dea51a9"
import script from "./yhbHumanFace.vue?vue&type=script&lang=js"
export * from "./yhbHumanFace.vue?vue&type=script&lang=js"
import style0 from "./yhbHumanFace.vue?vue&type=style&index=0&id=0dea51a9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports